export default __webpack_public_path__ + "static/media/search-zip-code.1a76421b.png";